<template>
  <component
    :is="comp"
    class="bg-static-info-low rounded-lg flex flex-row items-center p-8"
    :class="{
      'hover:bg-static-info-mid-hover focus:bg-static-info-mid-hover motion-safe:transition-colors motion-safe:duration-200 motion-safe:ease-in':
        hasLink,
    }"
    @click="emit('click')"
  >
    <div
      class="mr-8 flex h-40 w-40 shrink-0 items-center justify-center md:h-48 md:w-48"
    >
      <slot name="icon" />
    </div>
    <div class="flex w-full items-center justify-between text-left">
      <div class="flex flex-col">
        <div class="body-2-bold">
          <slot name="title" />
        </div>
        <div class="caption">
          <slot name="subtitle" />
        </div>
      </div>
      <div class="ml-8 flex h-40 w-40 items-center">
        <IconChevronRight v-if="hasLink" class="h-24 w-full" />
      </div>
    </div>
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { IconChevronRight } from '@ds/icons/IconChevronRight'

const props = withDefaults(
  defineProps<{
    hasLink?: boolean
  }>(),
  { hasLink: false },
)

const emit = defineEmits(['click'])

const comp = computed(() => {
  return props.hasLink ? 'button' : 'div'
})
</script>
